// @ts-nocheck
import React from "react";
import vivasLogo from "../assets/images/vivas-logo.png";
import { useLanguageContext } from "../context/languageContext";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

/**
 * Welcome banner.
 *
 * Deep navy with a sand accent, and the logo given a tile of its own so it reads
 * as a mark rather than as decoration. The logo artwork is white, so it sits
 * straight on the navy - a white plate behind it would swallow it.
 */
export const WelcomeBanner = () => {
    const { t } = useLanguageContext();
    const location = useLocation();
    const serviceRequestsCount = useSelector((state) => state.details.serviceRequests?.length || 0);
    // Set when the guest scans the QR code in their room or on their table
    const roomId = useSelector((state) => state.business.roomId);
    const tableId = useSelector((state) => state.business.tableId);
    const isRoomService = location.pathname.includes("room-service");

    const showRequestsLink = isRoomService && serviceRequestsCount > 0;
    const showStrip = Boolean(roomId || tableId || showRequestsLink);

    return (
        <section className="px-4 pt-4 pb-1 animate-app-reveal text-sharp">
            <div className="relative overflow-hidden rounded-[1.25rem] bg-navy shadow-[0_10px_30px_-16px_rgba(11,30,59,0.9)]">
                {/* Depth, kept subtle so the logo stays the brightest thing here */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute -top-20 -right-16 w-56 h-56 rounded-full bg-navy-light opacity-60 blur-[70px]"></div>
                    <div
                        className="absolute inset-0 opacity-[0.05]"
                        style={{ backgroundImage: "radial-gradient(circle, white 1px, transparent 0)", backgroundSize: "18px 18px" }}
                    ></div>
                </div>

                <div className="relative z-10 flex items-center gap-4 px-5 py-5">
                    <div className="flex-shrink-0 w-[68px] h-[68px] rounded-2xl bg-white/[0.07] ring-1 ring-white/15 flex items-center justify-center">
                        <img
                            src={vivasLogo}
                            alt="Hotel Vivas"
                            className="w-[56px] h-[56px] object-contain"
                        />
                    </div>

                    <div className="min-w-0 flex-1 space-y-1">
                        <p className="text-[8px] font-black uppercase tracking-[0.22em] text-sand">
                            Hotel Vivas Luxury
                        </p>
                        <h1 className="text-[17px] sm:text-xl font-clash text-white tracking-tight leading-tight truncate">
                            {t("welcome_banner")}
                        </h1>
                        <p className="text-white/45 text-[10px] font-medium leading-snug line-clamp-2">
                            {t("glad_message")}
                        </p>
                    </div>
                </div>

                {showStrip && (
                    <div className="relative z-10 flex items-center justify-between gap-3 px-5 py-2.5 bg-white/[0.06] border-t border-white/10">
                        {showRequestsLink ? (
                            <Link
                                to="/service-status"
                                className="inline-flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.2em] text-white/70 active:text-white transition-colors"
                            >
                                <span>{t("Requested Services")}</span>
                                <span className="px-1.5 py-0.5 rounded bg-white/10 text-[8px] text-white">
                                    {serviceRequestsCount}
                                </span>
                            </Link>
                        ) : (
                            <span className="text-[9px] font-black uppercase tracking-[0.2em] text-white/50">
                                {t("welcome_banner")}
                            </span>
                        )}

                        {(roomId || tableId) && (
                            <span className="flex-shrink-0 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-sand text-navy text-[9px] font-black uppercase tracking-wider">
                                {roomId ? `${t("Room")} ${roomId}` : `${t("tableNo")} ${tableId}`}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </section>
    );
};
